import { FSBrand, mapFSBrand } from "../Brand";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSLocation, mapFSLocation } from "../Location";
import { FSDataOrder, mapFSDataOrder } from "../Order";

/* **************************************************** Finishing Shedule Other Data */
export interface FSOtherData {
    id: number;
    fs_data_id: number;
    brand_id: number | null;
    flooring_screed: string;
    number: number | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    brand: FSBrand | null;
}

export const mapFSOtherData = (data: any): FSOtherData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSOtherData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        brand_id: data.brand_id || null,
        flooring_screed: data.flooring_screed,
        number: data.number || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        brand: data.brand ? mapFSBrand(data.brand) : null,
    };

    return res;
};

export const mapFSOtherDatas = (data: any[]): FSOtherData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSOtherData);
};


/* **************************************************** Finishing Shedule Other */
export interface FSOther {
    id: number;
    fs_feature_id: number;
    category: string | null;
    location_name: string | null;
    location_id: number | null;
    is_default_feature: 1 | 0;
    location: FSLocation | null;
    data_other: FSOtherData[];
}

export const mapFSOther = (data: any): FSOther => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSOther = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category || null,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        location: data.location ? mapFSLocation(data.location) : null,
        data_other: Array.isArray(data.data_other) ? mapFSOtherDatas(data.data_other) : [],
    };

    return res;
};

export const mapFSOthers = (data: any[]): FSOther[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSOther);
};
